// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","container":"b1fv80Lx","session":"JxogyQCR","sessionNotActive":"evKcUx+9"};